/* eslint-disable arrow-body-style */
/* eslint-disable no-unused-vars */
import React from "react";
import { useSelector } from "react-redux";
import UnauthorizedAccess from "../../components/UnauthorizedAccess/UnauthorizedAccess";

const withAllowedRoles = (WrappedComponent, requiredRoles = []) => (props) => {
  const roles = useSelector((state) => state.auth.user.roles || []);
  const hasRequiredRole = roles.some((role) => requiredRoles.includes(role));

  if (!hasRequiredRole) {
    return <UnauthorizedAccess />;
  }

  return <WrappedComponent {...props} />;
};

export default withAllowedRoles;
